import React, { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import ContactModal from "./hero/ContactModal";
import toast from "react-hot-toast";
import axios from "axios";
import hqaaLogo from "../../assets/images/hqaa.jpeg";
import collagenImage from "../../assets/images/collagen_image.png";
import propackImage from "../../assets/images/propack_image.png";
import CookieBanner from "./CookieBanner";
const styles = `
@import url('https://fonts.googleapis.com/css2?family=Playfair+Display:ital,wght@0,400;0,500;1,400&family=Syne:wght@300;400;500;600&display=swap');

.pm-root *{box-sizing:border-box;margin:0;padding:0}
.pm-root{
  --ink:#1E2A3A;
  --slate-hero:#4A5272;
  --green:#4E8A3C;
  --green-light:#7BBF6A;
  --green-pale:#EBF5E7;
  --aqua:#7BBCC8;
  --aqua-pale:#E8F4F7;
  --gold:#C9A96E;
  --cream:#F7F6F2;
  --muted:#6B7A8D;
  --border:rgba(30,42,58,0.1);
  --white:#FFFFFF;
}
.pm-root{font-family:'Syne',sans-serif;color:var(--ink);background:var(--white);width:100%;overflow-x:hidden}
.pm-serif{font-family:'Playfair Display',Georgia,serif}

/* HERO */
.pm-hero{display:grid;grid-template-columns:1fr 1fr;min-height:calc(100vh - 64px - 46px);width:100%}
.pm-hero-left{
  background:var(--cream);
  padding:5rem max(2.5rem, calc((100vw - 1280px)/2 + 2.5rem)) 5rem max(2.5rem, calc((100vw - 1280px)/2 + 2.5rem));
  display:flex;flex-direction:column;justify-content:center;
}
.pm-hero-tag{display:inline-flex;align-items:center;gap:8px;margin-bottom:1.75rem}
.pm-hero-tag-dot{width:6px;height:6px;background:var(--green);border-radius:50%}
.pm-hero-tag-txt{font-size:10px;letter-spacing:2.5px;text-transform:uppercase;color:var(--muted)}
.pm-hero h1{font-family:'Playfair Display',serif;font-size:52px;color:var(--ink);line-height:1.15;margin-bottom:1.5rem;font-weight:400}
.pm-hero h1 strong{font-weight:500;font-style:italic;color:var(--green)}
.pm-hero-body{font-size:14px;color:var(--muted);line-height:1.8;max-width:400px;margin-bottom:2.5rem;font-weight:300}
.pm-btn-green{background:var(--green);color:white;font-size:12px;font-weight:500;padding:13px 28px;border-radius:6px;border:none;cursor:pointer;letter-spacing:0.5px;font-family:'Syne',sans-serif;transition:background 0.2s}
.pm-btn-green:hover{background:#3D7030}

.pm-hero-right{
  position:relative;overflow:hidden;
  display:flex;flex-direction:column;justify-content:center;
  padding:5rem max(2.5rem, calc((100vw - 1280px)/2 + 2.5rem)) 5rem 3rem;
  background:linear-gradient(160deg, #C8DFC2 0%, #B8D8D8 50%, #A8C8D4 100%);
}
/* Soft organic texture overlay */
.pm-hero-right::before{
  content:'';position:absolute;inset:0;
  background:
    radial-gradient(ellipse at 80% 20%, rgba(255,255,255,0.35) 0%, transparent 55%),
    radial-gradient(ellipse at 20% 80%, rgba(123,188,200,0.25) 0%, transparent 50%);
  pointer-events:none;
}
.pm-hero-cert{position:absolute;top:2.5rem;right:max(2.5rem, calc((100vw - 1280px)/2 + 2.5rem));z-index:3;border-radius:8px;overflow:hidden;box-shadow:0 4px 16px rgba(74,82,114,0.2)}
.pm-hero-cert img{display:block;height:72px;width:auto}

/* PRODUCT CARDS */
.pm-cards{position:relative;z-index:2;display:flex;flex-direction:column;gap:12px;width:100%;max-width:460px}
.pm-card{
  background:rgba(255,255,255,0.75);
  backdrop-filter:blur(8px);
  border:1px solid rgba(255,255,255,0.9);
  border-left:3px solid var(--green);
  border-radius:10px;
  padding:1.25rem 1.5rem;
  cursor:pointer;
  transition:all 0.25s;
  display:flex;align-items:flex-start;gap:1rem;
  box-shadow:0 2px 12px rgba(74,82,114,0.08);
}
.pm-card:hover,.pm-card.pm-active{
  background:rgba(255,255,255,0.92);
  border-left-color:var(--green);
  box-shadow:0 6px 24px rgba(74,82,114,0.15);
  transform:translateX(3px);
}
.pm-card-icon{
  width:40px;height:40px;border-radius:8px;
  background:linear-gradient(135deg, var(--green-pale), var(--aqua-pale));
  display:flex;align-items:center;justify-content:center;
  flex-shrink:0;font-size:19px;
  box-shadow:0 1px 4px rgba(78,138,60,0.15);
}
.pm-card h3{font-family:'Syne',sans-serif;font-size:13px;font-weight:500;color:var(--ink);margin-bottom:0.3rem;letter-spacing:0.2px;line-height:1.4}
.pm-card p{font-family:'Syne',sans-serif;font-size:11.5px;color:var(--muted);line-height:1.65;font-weight:300}
.pm-card-link{
  font-family:'Syne',sans-serif;font-size:10px;color:var(--green);
  letter-spacing:0.8px;text-transform:uppercase;
  margin-top:0.5rem;display:inline-flex;align-items:center;gap:4px;
  font-weight:500;opacity:0;transition:opacity 0.2s;
}
.pm-card:hover .pm-card-link,.pm-card.pm-active .pm-card-link{opacity:1}

/* Right panel label */
.pm-right-label{
  position:relative;z-index:2;
  font-family:'Syne',sans-serif;
  font-size:10px;letter-spacing:2.5px;text-transform:uppercase;
  color:rgba(30,42,58,0.4);margin-bottom:1.25rem;font-weight:400;
}

/* MODAL */
.pm-modal-overlay{position:fixed;inset:0;background:rgba(30,42,58,0.55);backdrop-filter:blur(6px);z-index:1000;display:flex;align-items:center;justify-content:center;padding:1.5rem}
.pm-modal{background:white;border-radius:12px;width:100%;max-width:520px;position:relative;box-shadow:0 24px 60px rgba(30,42,58,0.2)}
.pm-modal-band{height:3px;background:linear-gradient(90deg,var(--green),var(--aqua));border-radius:12px 12px 0 0}
.pm-modal-inner{padding:2rem}
.pm-modal-close {
  position: absolute;
  top: 1rem;
  right: 1rem;
  width: 28px;
  height: 28px;
  border-radius: 6px;
  background: var(--green-pale);
  border: 1px solid rgba(78, 138, 60, 0.25);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  z-index: 2;
  padding: 0;
  appearance: none;
  -webkit-appearance: none;
  color: var(--green); /* this drives the icon color */
}

.pm-modal-close:hover {
  background: var(--green-pale);
  
}

.pm-modal-close svg {
  width: 14px;
  height: 14px;
  display: block;
}
.pm-modal-eyebrow{font-size:10px;letter-spacing:2px;text-transform:uppercase;color:var(--green);margin-bottom:0.4rem}
.pm-modal-title{font-family:'Playfair Display',serif;font-size:22px;color:var(--ink);font-weight:400;margin-bottom:1rem}
.pm-product-img{width:100%;border-radius:8px;background:var(--cream);border:1px solid var(--border);padding:2rem;display:flex;align-items:center;justify-content:center;min-height:180px;margin-bottom:1.25rem}
.pm-product-img img{max-width:100%;max-height:200px;object-fit:contain}
.pm-product-tags{display:flex;flex-wrap:wrap;gap:6px;margin-bottom:0.75rem}
.pm-product-tag{font-size:10px;padding:4px 10px;border-radius:20px;background:var(--green-pale);color:var(--green);letter-spacing:0.3px}
.pm-modal-desc{font-size:12px;color:var(--muted);line-height:1.7}

/* Reimbursement modal */
.pm-reimb-wrap{position:relative;border-radius:8px;overflow:hidden;margin-bottom:1.25rem;min-height:160px}
.pm-reimb-blur-bg{
  width:100%;height:160px;display:flex;align-items:center;justify-content:center;
  background:linear-gradient(135deg,#e8f0e8,#d0e8d4);
  filter:blur(3px);transform:scale(1.05);
}
.pm-reimb-doc{width:75%;background:white;border-radius:4px;padding:1.25rem;display:flex;flex-direction:column;gap:7px}
.pm-reimb-line{height:7px;background:#ccc;border-radius:4px}
.pm-reimb-overlay{position:absolute;inset:0;background:rgba(30,42,58,0.4);backdrop-filter:blur(2px);display:flex;align-items:center;justify-content:center}
.pm-reimb-badge{background:var(--gold);border-radius:6px;padding:7px 16px;font-size:11px;font-weight:600;color:#3A2800;letter-spacing:0.5px}
.pm-email-row{display:flex;gap:8px}
.pm-email-input{flex:1;background:var(--cream);border:1px solid var(--border);border-radius:6px;padding:0.7rem 1rem;font-size:13px;font-family:'Syne',sans-serif;color:var(--ink);outline:none;transition:border-color 0.2s}
.pm-email-input::placeholder{color:rgba(30,42,58,0.3)}
.pm-email-input:focus{border-color:var(--green);background:white}
.pm-email-btn{background:#4E8A3C !important;color:white;border:none;cursor:pointer;padding:0.7rem 1.25rem;border-radius:6px;font-size:12px;font-weight:500;font-family:'Syne',sans-serif;letter-spacing:0.5px;white-space:nowrap;transition:background 0.2s;opacity:1!important}
.pm-email-btn:hover{background:#3D7030}
.pm-email-btn:disabled{opacity:0.5!important;cursor:not-allowed}
.pm-email-note{font-size:11px;color:var(--muted);margin-top:0.5rem}

/* MARQUEE */
.pm-marquee-bar{background:#5A7A52;padding:12px 0;overflow:hidden;width:100%}
.pm-marquee-inner{display:flex;gap:48px;white-space:nowrap;animation:pm-scroll 20s linear infinite}
.pm-marquee-item{font-family:'Syne',sans-serif;font-size:11px;letter-spacing:2px;text-transform:uppercase;color:rgba(255,255,255,0.75);display:inline-flex;align-items:center;gap:12px;flex-shrink:0}
.pm-marquee-item::before{content:'';width:4px;height:4px;background:rgba(255,255,255,0.5);border-radius:50%;flex-shrink:0}
@keyframes pm-scroll{0%{transform:translateX(0)}100%{transform:translateX(-50%)}}

/* SERVE */
.pm-serve{padding:5rem max(2.5rem, calc((100vw - 1280px)/2 + 2.5rem));background:var(--cream)}
.pm-row-header{display:flex;align-items:flex-end;justify-content:space-between;margin-bottom:2.5rem;gap:2rem}
.pm-eyebrow{font-family:'Syne',sans-serif;font-size:10px;letter-spacing:2.5px;text-transform:uppercase;color:var(--green);margin-bottom:0.6rem}
.pm-h2{font-family:'Playfair Display',serif;font-size:32px;color:var(--ink);line-height:1.25;font-weight:400}
.pm-rh-right p{font-family:'Syne',sans-serif;font-size:13px;color:var(--muted);line-height:1.75;max-width:340px;font-weight:300}
.pm-serve-cards{display:grid;grid-template-columns:repeat(3,minmax(0,1fr));gap:1.5rem}
.pm-sc{
  background:white;
  border:1px solid rgba(78,138,60,0.12);
  border-top:3px solid var(--green);
  border-radius:10px;
  padding:2rem 1.75rem;
  cursor:pointer;
  transition:all 0.25s;
  box-shadow:0 2px 12px rgba(30,42,58,0.05);
}
.pm-sc:hover{
  background:var(--green-pale);
  border-color:rgba(78,138,60,0.3);
  box-shadow:0 6px 24px rgba(78,138,60,0.12);
  transform:translateY(-2px);
}
.pm-sc-num{font-family:'Playfair Display',serif;font-size:38px;color:var(--green);opacity:0.18;margin-bottom:1rem;line-height:1}
.pm-sc h3{font-family:'Syne',sans-serif;font-size:14px;font-weight:500;color:var(--ink);margin-bottom:0.6rem;letter-spacing:0.2px}
.pm-sc p{font-family:'Syne',sans-serif;font-size:12px;color:var(--muted);line-height:1.75;font-weight:300}
.pm-sc-link{
  font-family:'Syne',sans-serif;display:inline-flex;align-items:center;gap:6px;
  font-size:11px;color:var(--green);margin-top:1.25rem;
  letter-spacing:0.5px;font-weight:500;cursor:pointer;
  transition:gap 0.2s;
}
.pm-sc:hover .pm-sc-link{gap:10px}

/* CTA */
.pm-cta{
  padding:5rem max(2.5rem, calc((100vw - 1280px)/2 + 2.5rem));
  background:linear-gradient(160deg, #3A5C35 0%, #4A6A60 50%, #3A5870 100%);
  display:grid;grid-template-columns:1fr 1fr;gap:4rem;align-items:center;
  position:relative;overflow:hidden;
}
.pm-cta::before{
  content:'';position:absolute;inset:0;
  background:
    radial-gradient(ellipse at 15% 50%, rgba(200,223,194,0.15) 0%, transparent 55%),
    radial-gradient(ellipse at 85% 30%, rgba(123,188,200,0.12) 0%, transparent 50%);
  pointer-events:none;
}
.pm-cta-left{position:relative;z-index:1}
.pm-cta-left .pm-eyebrow{color:var(--green-light)}
.pm-cta-left h2{font-family:'Playfair Display',serif;font-size:32px;color:white;font-weight:400;line-height:1.3;margin-top:0.5rem}
.pm-cta-left p{font-family:'Syne',sans-serif;font-size:13px;color:rgba(255,255,255,0.55);margin-top:0.75rem;line-height:1.8;font-weight:300}
.pm-cta-right{position:relative;z-index:1;display:flex;flex-direction:column;gap:10px}
.pm-cta-card{
  background:rgba(255,255,255,0.08);
  border:1px solid rgba(255,255,255,0.14);
  border-radius:10px;padding:1.25rem 1.5rem;
  display:flex;align-items:center;justify-content:space-between;gap:1rem;
  cursor:pointer;transition:all 0.22s;
}
.pm-cta-card:hover{
  background:rgba(255,255,255,0.15);
  border-color:rgba(200,223,194,0.5);
  transform:translateX(3px);
}
.pm-cc-left p{font-family:'Syne',sans-serif;font-size:13px;font-weight:500;color:white}
.pm-cc-left span{font-family:'Syne',sans-serif;font-size:11px;color:rgba(255,255,255,0.45);margin-top:2px;display:block;font-weight:300}
.pm-cc-arrow{font-size:16px;color:var(--green-light);transition:transform 0.2s}
.pm-cta-card:hover .pm-cc-arrow{transform:translateX(3px)}
.pm-phone-line{font-family:'Syne',sans-serif;text-align:center;font-size:12px;color:rgba(255,255,255,0.3);letter-spacing:0.3px;margin-top:4px}

/* RESPONSIVE */
@media (max-width: 768px) {
  .pm-hero{grid-template-columns:1fr;min-height:auto}
  .pm-hero-left{padding:3.5rem 1.5rem 3rem;order:1}
  .pm-hero h1{font-size:36px}
  .pm-hero-body{font-size:13px;max-width:100%}
  .pm-hero-right{padding:2.5rem 1.5rem 3rem;order:2}
  .pm-cards{max-width:100%}
  .pm-hero-cert{top:1.5rem;right:1.5rem}
  .pm-row-header{flex-direction:column;align-items:flex-start;gap:1rem}
  .pm-rh-right p{max-width:100%}
  .pm-h2{font-size:26px}
  .pm-serve{padding:3.5rem 1.5rem}
  .pm-serve-cards{grid-template-columns:1fr}
  .pm-cta{grid-template-columns:1fr;gap:2.5rem;padding:3.5rem 1.5rem}
  .pm-cta-left h2{font-size:26px}
}
@media (max-width: 480px) {
  .pm-hero-left{padding:2.5rem 1.25rem 2rem}
  .pm-hero h1{font-size:30px}
  .pm-btn-green{width:100%;text-align:center}
  .pm-hero-right{padding:2rem 1.25rem 2.5rem}
  .pm-serve{padding:3rem 1.25rem}
  .pm-cta{padding:3rem 1.25rem}
  .pm-h2{font-size:24px}
  .pm-cta-left h2{font-size:24px}
  .pm-email-row{flex-direction:column}
}
@media (min-width: 1440px) {
  .pm-hero h1{font-size:58px}
  .pm-hero-body{font-size:15px;max-width:480px}
  .pm-hero-left{padding:5rem max(4rem, calc((100vw - 1400px)/2 + 4rem)) 5rem max(4rem, calc((100vw - 1400px)/2 + 4rem))}
  .pm-hero-right{padding:5rem max(4rem, calc((100vw - 1400px)/2 + 4rem)) 5rem 4rem}
  .pm-cards{max-width:520px}
  .pm-hero-cert{top:3rem;right:max(4rem, calc((100vw - 1400px)/2 + 4rem))}
  .pm-h2{font-size:36px}
  .pm-cta-left h2{font-size:36px}
}
@media (min-width: 1920px) {
  .pm-hero h1{font-size:66px}
  .pm-h2{font-size:40px}
  .pm-cta-left h2{font-size:40px}
}
`;

const marqueeItems = [
  "HQAA Certified","Advanced Wound Care","ProPack™ Clinical Bundles",
  "Collagen Dressings","HCPCS Coded","Physician Dispensing",
  "Home Health Solutions","Customized Healing Packs"
];

const CloseIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
    <path
      d="M6 6L18 18M18 6L6 18"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const ProductModal = ({ onClose, eyebrow, title, imagePlaceholder, imageComponent, tags, desc }) => (
  <motion.div className="pm-modal-overlay"
    initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }}
    onClick={(e) => { if (e.target === e.currentTarget) onClose(); }}
  >
   
      <motion.div className="pm-modal"
  initial={{ y: 20, scale: 0.97 }}
  animate={{ y: 0, scale: 1 }}
  exit={{ y: 12, scale: 0.97 }}
  transition={{ duration: 0.26 }}
>
      <div className="pm-modal-band"></div>
      <div className="pm-modal-inner">
        <button className="pm-modal-close" onClick={onClose}><CloseIcon /></button>
        <div className="pm-modal-eyebrow">{eyebrow}</div>
        <div className="pm-modal-title pm-serif">{title}</div>
        <div className="pm-product-img">
          {imageComponent ? imageComponent : (
            <div style={{ textAlign:'center', color:'#6B7A8D', fontSize:'13px' }}>
              <div style={{ fontSize:'42px', marginBottom:'8px' }}>{imagePlaceholder}</div>
            </div>
          )}
        </div>
        <p className="pm-modal-desc">{desc}</p>
      </div>
    </motion.div>
  </motion.div>
);

const Home = () => {
  const [contactOpen, setContactOpen] = useState(false);
  const [activeModal, setActiveModal] = useState(null); // 'propack' | 'collagen' | 'reimb'
  const [reimbEmail, setReimbEmail] = useState("");
  const [reimbSubmitting, setReimbSubmitting] = useState(false);
  const [formData, setFormData] = useState({
    name:"", facility:"", city:"", state:"", zip:"", phone:"", email:"", question:""
  });
  const [cookieConsent, setCookieConsent] = useState(() => localStorage.getItem("cookie_consent"));
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };
  const handleContactClose = () => {
    setContactOpen(false);
    setFormData({ name:"", facility:"", city:"", state:"", zip:"", phone:"", email:"", question:"" });
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    const { name, email, phone, question, facility, city, state, zip } = formData;
    if (!name||!facility||!city||!state||!zip||!phone||!email||!question) {
      toast.error("Please fill in all required fields."); return;
    }
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      toast.error("Please enter a valid email address."); return;
    }
    try {
      await axios.post("https://promedhealth-frontdoor-h4c4bkcxfkduezec.z02.azurefd.net/api/v1/contact-us/", formData);
      toast.success("Your message has been sent!");
      handleContactClose();
    } catch { toast.error("Failed to send message. Please try again."); }
  };

  const handleReimbSubmit = async () => {
    if (!reimbEmail || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(reimbEmail)) {
      toast.error("Please enter a valid email."); return;
    }
    setReimbSubmitting(true);
    try {
      await axios.post("https://promedhealth-frontdoor-h4c4bkcxfkduezec.z02.azurefd.net/api/v1/guide/request-guide/", { email: reimbEmail });
      toast.success("Guide will be sent shortly! Thanks for reaching out to Promed Health+");
      setReimbEmail(""); setActiveModal(null);
    } catch { toast.error("Failed to submit. Please try again."); }
    finally { setReimbSubmitting(false); }
  };

  return (
    <>
      <style dangerouslySetInnerHTML={{ __html: styles }} />
      <div className="pm-root">

        {/* ── HERO ── */}
        <div className="pm-hero">

          {/* LEFT */}
          <div className="pm-hero-left">
            <div className="pm-hero-tag">
              <div className="pm-hero-tag-dot"></div>
              <span className="pm-hero-tag-txt">Advanced Wound Care</span>
            </div>
            <h1 className="pm-serif">
              Healing that<br />moves <strong>at the speed</strong><br />of medicine.
            </h1>
            <p className="pm-hero-body">
              ProMed Health Plus delivers advanced wound care products and bundles built for the way modern providers work—and the way patients deserve to heal.
            </p>
            <button className="pm-btn-green" onClick={() => setContactOpen(true)}>
              Talk to Our Team
            </button>
          </div>

          {/* RIGHT */}
          <div className="pm-hero-right">
            <div className="pm-hero-cert">
              <img src={hqaaLogo} alt="HQAA Certified Accredited Provider" />
            </div>

            <div className="pm-right-label">Our Clinical Solutions</div>
            <div className="pm-cards">
              {[
                {
                  id:"propack", icon:"🧰",
                  title:"ProPack™ Bundled Clinical Kits",
                  desc:"Everything needed for a standard 30-day wound treatment cycle in a single curated unit.",
                  link:"View Kit →"
                },
                {
                  id:"collagen", icon:"🌿",
                  title:"Collagen Collection — Clinical Sheets",
                  desc:"Pure bovine collagen matrix designed to stimulate healing in stagnant, chronic wounds.",
                  link:"View Product →"
                },
                {
                  id:"reimb", icon:"📋",
                  title:"Reimbursement Guides — ICD Support",
                  desc:"Navigate complexity with ease. Get your free ICD coding guide delivered to your inbox.",
                  link:"Get Free Guide →"
                }
              ].map(card => (
                <div
                  key={card.id}
                  className={`pm-card ${activeModal === card.id ? "pm-active" : ""}`}
                  onClick={() => setActiveModal(card.id)}
                >
                  <div className="pm-card-icon">{card.icon}</div>
                  <div>
                    <h3>{card.title}</h3>
                    <p>{card.desc}</p>
                    <span className="pm-card-link">{card.link}</span>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* MARQUEE */}
        <div className="pm-marquee-bar">
          <div className="pm-marquee-inner">
            {[...marqueeItems,...marqueeItems].map((item,i) => (
              <span key={i} className="pm-marquee-item">{item}</span>
            ))}
          </div>
        </div>

        {/* WHO WE SERVE */}
        <section className="pm-serve">
          <div className="pm-row-header">
            <div>
              <div className="pm-eyebrow">Who We Serve</div>
              <h2 className="pm-h2 pm-serif">Every path to recovery,<br />thoughtfully supported.</h2>
            </div>
            <div className="pm-rh-right">
              <p>We work with physicians, wound care centers, home health providers, and patients—each with a tailored approach, not a one-size solution.</p>
            </div>
          </div>
          <div className="pm-serve-cards">
            {[
              { n:"01", h:"Physicians & Wound Centers", p:"In-office dispensing programs with bundled ProPack™ kits, dedicated account management, and reimbursement-coded products designed for clinical efficiency.", l:"Request physician info →" },
              { n:"02", h:"Home Health & Patients", p:"Clinician-guided wound care delivered directly to patients. Education resources, live support, and products that make recovery at home manageable and clear.", l:"Learn about patient care →" },
              { n:"03", h:"Facilities & Distributors", p:"Wholesale arrangements with Net 30 terms, custom kit configurations, and a dedicated field sales network for SNFs, DMEs, and wound care facilities.", l:"Inquire about wholesale →" }
            ].map((c,i) => (
              <div key={i} className="pm-sc">
                <div className="pm-sc-num">{c.n}</div>
                <h3>{c.h}</h3>
                <p>{c.p}</p>
                <div className="pm-sc-link" onClick={() => setContactOpen(true)}>{c.l}</div>
              </div>
            ))}
          </div>
        </section>

        {/* CTA */}
        <div className="pm-cta">
          <div className="pm-cta-left">
            <div className="pm-eyebrow">Get Started</div>
            <h2 className="pm-serif">Let's build the right wound care program for you.</h2>
            <p>Whether you're a provider, a patient, or a facility—our team is here to match you with the right solution and walk you through every step.</p>
          </div>
          <div className="pm-cta-right">
            {[
              { title:"Schedule a call with our team", sub:"Physician & facility inquiries" },
              { title:"Request a product sample", sub:"Try before you commit" },
              { title:"Patient or home care inquiry", sub:"We'll guide you to the right solution" }
            ].map((card,i) => (
              <div key={i} className="pm-cta-card" onClick={() => setContactOpen(true)}>
                <div className="pm-cc-left"><p>{card.title}</p><span>{card.sub}</span></div>
                <div className="pm-cc-arrow">→</div>
              </div>
            ))}
            <div className="pm-phone-line">Or call us directly · (888) 338-0490</div>
          </div>
        </div>

      </div>

      {/* ── MODALS ── */}
      <AnimatePresence>

        {activeModal === "propack" && (
          <ProductModal
            key="propack"
            onClose={() => setActiveModal(null)}
            eyebrow="Clinical Kit"
            title="ProPack™ Bundled Clinical Kits"
            imagePlaceholder={null}
            imageComponent={<img src={propackImage} alt="ProPack Clinical Bundle" />}
            tags={["Collagen Sheets","Medical Tape","Gauze (30 pieces)","Wound Wash","Gloves"]}
            // desc="Everything needed for a standard 30-day wound treatment cycle in a single curated unit. Designed for in-office dispensing with HCPCS-coded components for easy reimbursement."
          />
        )}

        {activeModal === "collagen" && (
          <ProductModal
            key="collagen"
            onClose={() => setActiveModal(null)}
            eyebrow="Collagen Collection"
            title="Clinical Collagen Sheets"
            imagePlaceholder={null}
            imageComponent={<img src={collagenImage} alt="Clinical Collagen Sheets" />}
            tags={["5 Collagen Sheets","1 Product Box","1 Wound Wash"]}
            // desc="Pure bovine collagen matrix designed to stimulate healing in stagnant, chronic wounds. Available in 2×2, 4×4, and 7×7 sheet sizes and 1g powder format."
          />
        )}

        {activeModal === "reimb" && (
          <motion.div className="pm-modal-overlay"
            key="reimb"
            initial={{ opacity:0 }} animate={{ opacity:1 }} exit={{ opacity:0 }}
            onClick={(e) => { if (e.target===e.currentTarget) setActiveModal(null); }}
          >
            <motion.div className="pm-modal"
  initial={{ y:20, scale:0.97 }}
  animate={{ y:0, scale:1 }}
  exit={{ y:12, scale:0.97 }}
  transition={{ duration:0.26 }}
>
              <div className="pm-modal-band"></div>
              <div className="pm-modal-inner">
                <button className="pm-modal-close" onClick={() => setActiveModal(null)}><CloseIcon /></button>
                <div className="pm-modal-eyebrow">Free Resource</div>
                <div className="pm-modal-title pm-serif">Get Your ICD Reimbursement Guide</div>

                {/* Blurred guide preview — swap .pm-reimb-blur-bg for your actual guide image */}
                <div className="pm-reimb-wrap">
                  <div className="pm-reimb-blur-bg">
                    <div className="pm-reimb-doc">
                      {["90%","60%","80%","70%","55%","85%","65%"].map((w,i) => (
                        <div key={i} className="pm-reimb-line" style={{ width:w }}></div>
                      ))}
                    </div>
                  </div>
                  <div className="pm-reimb-overlay">
                    <div className="pm-reimb-badge">📋 ICD Coding Guide — Free Download</div>
                  </div>
                </div>

                <p className="pm-modal-desc" style={{ marginBottom:'1rem' }}>
                  Enter your email and we'll send you our free ICD coding guide — up-to-date HCPCS codes, wound care billing tips, and reimbursement best practices for providers.
                </p>
                <div className="pm-email-row">
                  <input
                    className="pm-email-input"
                    type="email"
                    placeholder="your@practice.com"
                    value={reimbEmail}
                    onChange={e => setReimbEmail(e.target.value)}
                    onKeyDown={e => { if(e.key==='Enter') handleReimbSubmit(); }}
                  />
                  <button className="pm-email-btn" onClick={handleReimbSubmit} disabled={reimbSubmitting}>
                    {reimbSubmitting ? "Submitting..." : "Submit"}
                  </button>
                </div>
                {/* <p className="pm-email-note">No spam, ever. Unsubscribe anytime.</p> */}
              </div>
            </motion.div>
          </motion.div>
        )}

        {contactOpen && (
          <ContactModal key="contact" open={contactOpen} handleClose={handleContactClose}
            formData={formData} handleChange={handleChange} handleSubmit={handleSubmit} />
        )}

      </AnimatePresence>
      {/* ── COOKIE BANNER ── */}       
      {!cookieConsent && (
        <CookieBanner
          onAccept={() => { localStorage.setItem("cookie_consent", "accepted"); setCookieConsent("accepted"); }}
          onDecline={() => { localStorage.setItem("cookie_consent", "declined"); setCookieConsent("declined"); }}
        />
      )}
    </>
  );
};

export default Home;